import { cloneDeep, unset } from "lodash";
import { minimums } from "./constants";

export const calSubTot = (row) => {
  const pricePerLot = row.pricePerLot * row.lotAmount;
  const amount = row.price * row.amount;
  const fiscalValue = (row.fiscalValue * row.percentage) / 100;
  const subTot = amount + fiscalValue + pricePerLot;
  let x = Math.floor(subTot * 100) / 100;
  if (row.urgent) {
    x = x * 0.5 + x;
  }
  return x;
};

export const getAccessor = (row) => {
  return row.amount === null && row.articleName === null
    ? row.articleDescription
    : row.amount !== null
    ? row.articleDescription
    : row.articleName;
};

export const getReformatItem = (item) => {
  const copyItem = cloneDeep(item);
  unset(copyItem, "inputs");
  unset(copyItem, "order");
  unset(copyItem, "articleName");
  return copyItem;
};

export const checkNaN = (value) => {
  if (!value) {
    return 0;
  } else {
    return parseInt(value);
  }
};

export const checkMin = (value, field) => {
  if (value < minimums[field]) {
    return minimums[field];
  }
  return value;
};

export const onlyNum = (value) => {
  const pattern = /\D/g;
  const number = value.replace(pattern, "");
  return number;
};

export const compare = (a, b) => {
  if (a.order < b.order) {
    return -1;
  }
  if (a.order > b.order) {
    return 1;
  }
  return 0;
};

export const sortElements = (arts) => {
  const copyArts = cloneDeep(arts);
  copyArts.map((art) => {
    art.subRows.sort(compare);
  });
  return copyArts.sort(compare);
};
